import { useWorkflowFieldValues } from 'features/libra/fieldValues/useWorkflowFieldValues'
import { unwrapFieldValue } from 'features/libra/ontology/ontologyFieldDefaults'
import { useActiveScopeOntologyFields } from 'features/libra/ontology/useOntologyFields'
import { ConditionalFormView } from 'features/libra/stepComponents/conditionalForm/ConditionalFormView'
import { useWorkflow } from 'features/libra/WorkflowContext'
import { z } from 'zod'

import { PlanningWorkPackExport } from './pdf/PlanningWorkPackExport'
import type { planningPreparationSchema } from './planningPreparationConfig'
import {
  inspectionAreaSchema,
  planningAreasConfigSchema,
} from './planningTypes'

export const PlanningPreparationForm = ({
  config,
  readonly,
}: {
  config: z.infer<typeof planningPreparationSchema>
  readonly: boolean
}) => {
  const { ontologyFields } = useActiveScopeOntologyFields()
  const workflow = useWorkflow()
  const formState = useWorkflowFieldValues({ ontologyFields, ...config })
  const exportPlanning = config.workPackStepId
    ? planningAreasConfigSchema.safeParse(
        workflow.steps.find((step) => step.id === config.workPackStepId)?.config
      ).data
    : undefined
  const areas = exportPlanning?.workPack
    ? inspectionAreaSchema
        .array()
        .safeParse(
          unwrapFieldValue(
            formState.resolvedFieldValues[exportPlanning.areasField]
          ) ?? []
        ).data
    : undefined
  return (
    <>
      <ConditionalFormView
        config={config}
        ontologyFields={ontologyFields}
        formState={formState}
        readonly={readonly}
      />
      {exportPlanning?.workPack && areas && (
        <PlanningWorkPackExport
          config={exportPlanning}
          exportConfig={exportPlanning.workPack}
          areas={areas}
          fieldValuesOverride={formState.resolvedFieldValues}
        />
      )}
    </>
  )
}
